// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-check-circle-outline
 * @tagname hzn-icon-check-circle-outline
 * @summary An individual icon for Horizon
 */
export class HznIconCheckCircleOutline extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.09091 12C2.09091 6.52736 6.52736 2.09091 12 2.09091C17.4726 2.09091 21.9091 6.52736 21.9091 12C21.9091 17.4726 17.4726 21.9091 12 21.9091C6.52736 21.9091 2.09091 17.4726 2.09091 12ZM12 0.0909119C5.42279 0.0909119 0.0909119 5.42279 0.0909119 12C0.0909119 18.5772 5.42279 23.9091 12 23.9091C18.5772 23.9091 23.9091 18.5772 23.9091 12C23.9091 5.42279 18.5772 0.0909119 12 0.0909119ZM17.7174 7.80827L9.93918 15.5864L6.40365 12.0509L4.98943 13.4651L9.23208 17.7078C9.6226 18.0983 10.2558 18.0983 10.6463 17.7078L19.1316 9.22248L17.7174 7.80827Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=check-circle-outline.js.map